<script>
    import { t, locale, locales } from "../../../scripts/i18n";
</script>

<div class="panel-inner-wrap">
    <div class="checkbox-w-label-wrap py-20px">
        <div class="custom-checkbox-wrap custom-checkbox-wrap-small mr-10px">
            <label class="checkbox-container">
                <input type="checkbox" checked>
                <span class="checkmark checkmark-small"></span>
            </label>
        </div>
        <div class="label-text-wrap text-left">Резервная копия подписок и подписчиков</div>
    </div>
    <div class="checkbox-w-label-wrap py-20px">
        <a href="#" type="button" class="purple-btn purple-btn_hover w-210px h-45px">Скачать архив (CSV)</a>
        Обновлено 2023-06-15 17:20:06
    </div>

    <div class="checkbox-w-label-wrap py-20px">
        <div class="custom-checkbox-wrap custom-checkbox-wrap-small mr-10px">
            <label class="checkbox-container">
                <input type="checkbox" checked>
                <span class="checkmark checkmark-small"></span>
            </label>
        </div>
        <div class="label-text-wrap text-left">Резервная копия публикаций</div>
    </div>

    <div class="checkbox-w-label-wrap py-20px">
        <a href="#" type="button" class="purple-btn purple-btn_hover w-210px h-45px">Скачать архив (CSV)</a>
        Обновлено 2023-06-15 17:20:06
    </div>

    <p class="create-backup-description">
        Внимание! Резервные копии обновляются раз в месяц
    </p>

</div>


<style>
    .py-20px {
        padding: 20px 0 0 0;
    }
    .purple-btn {
        margin-right: 10px;
    }
    .border-bottom {
        border-bottom: 1px solid grey;
    }
    .create-backup-description {
        text-align: center;
        color: #00000080;
        padding-top: 25px;
    }
    .checkbox-w-label-wrap {
        justify-content: left;
    }
    .checkbox-w-label-wrap .label-text-wrap {
        font-family: Roboto;
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 19px;
        color: #000;
    }
    .foreigners-params-wrap {
        padding-left: 27px;

        font-family: Roboto;
        font-style: normal;
        font-weight: 300;
        font-size: 14px;
        line-height: 16px;
        margin-top: 5px;
    }
    .foreigners-params-wrap .checkbox-w-label-wrap .label-text-wrap {
        font-family: Roboto;
        font-style: normal;
        font-weight: 300;
        font-size: 14px;
        line-height: 16px;
        margin-top: 5px;
    }
    .panel-inner-wrap {
        text-align: left;
        padding: 10px 25px;
        border: 1px solid #8001bd;
        box-sizing: border-box;
        border-radius: 10px;
    }
</style>